import { findAlternateId } from "./findAlternateId";
export function shortReportingYear(year) {
    return year >= 100 ? year.toString().slice(-2) : year.toString();
}
export function subjectForList(organizationName, reportingYear) {
    return `Tier II Non-Reporting Notification - ${organizationName} - RY${shortReportingYear(reportingYear)}`;
}
export const SIGNATURE = `If you have any questions, please reach out to us at 317-450-4557 or email support@encamp.com.

Thanks for keeping our state safe!

Best,
The Encamp Compliance Team
`;
export function formatAddress(f) {
    const parts = [
        f.streetAddress1 ?? "",
        f.streetAddress2 ?? "",
        [f.city, [f.state, f.zip].filter(Boolean).join(" ")].filter(Boolean).join(", "),
    ].filter(Boolean);
    return parts.join(", ").replace(/, ,/g, ", ").trim() || f.name;
}
/**
 * Format one facility line for list-style NNR templates.
 * Optional displayIdType (e.g. TIER2_AZ, TIER2_MANAGER) shows that alternate ID when present.
 * Format: "<Name> at <Address> (ID <value>, if displayIdType matches) - <Reason, if available>"
 */
export function formatFacilityLine(f, displayIdType) {
    const address = formatAddress(f);
    const matchedAltId = displayIdType && f.facilityAlternateIds?.length
        ? findAlternateId(f.facilityAlternateIds, [displayIdType])
        : undefined;
    const idPart = matchedAltId?.value;
    const reason = f.newlyNotReportingReason?.trim();
    const base = `${f.name} at ${address}`;
    const withId = idPart != null ? `${base} (ID ${idPart})` : base;
    if (reason == null) {
        return withId;
    }
    return `${withId} - ${reason}`;
}
export function getReportingYear(communication) {
    const report = communication.tierIIReports[0];
    if (report?.reportingYear == null) {
        throw new Error("Newly-not-reporting template requires communication.tierIIReports[0].reportingYear");
    }
    return report.reportingYear;
}
/** List-style body from communication (General, T2M, AZ). Plain text with newlines.
 * Same text is used for: (1) PDF via renderTextToCoverLetterPdf (splits on \n), (2) email body.
 * SendGrid sendEmail(useTemplate: true) converts \n → <br> via textForHtmlEmail so HTML email displays line breaks. */
export function renderListBodyFromCommunication(communication, options) {
    if (communication.facilities.length === 0) {
        throw new Error("Newly-not-reporting list template requires at least one facility");
    }
    const displayIdType = options?.displayIdType;
    const facilityList = communication.facilities
        .map((f) => formatFacilityLine(f, displayIdType))
        .join("\n");
    const organizationName = communication.tenant.name;
    const reportingYear = getReportingYear(communication);
    return `To whom it may concern,

As part of our commitment to environmental compliance and community safety, please see the below list of facilities that are no longer required to submit a Tier II report for Reporting Year ${reportingYear}:

${facilityList}

This notification is filed by Encamp, Inc. on behalf of ${organizationName}.

Each facility listed in the attachment was previously a Tier II reporter and has since fallen below applicable hazardous chemical reporting thresholds or has been closed, transferred, or sold prior to the reporting period. No Tier II submission will be filed for these facilities for RY${shortReportingYear(reportingYear)}.

${SIGNATURE}`;
}
//# sourceMappingURL=shared.js.map